// client/src/components/common/Layout.js
import React from 'react';
import Header from './Header';
import Footer from './Footer';

function Layout({ children, showHeader = true, showFooter = true }) { //show header and footer by default
    return (
        <>
            {showHeader && <Header />}
                <div className="content-wrapper">
                <main>
                    {children}
                </main>
            </div>
            {showFooter && <Footer />}
        </>
    );
}

export default Layout;